export const valueChangeStyles = {
  display: 'flex',
  flexWrap: 'wrap',
  alignItems: 'baseline',
  columnGap: '4px',
};

export const arrowStyles = {
  color: ({ palette }) => palette.text.secondary,
};
